<core-modal-window header="Einstellungen" [modalRef]="modalRef">
  <div slot="body" class="flex flex-col gap-lg p-lg">
    <app-settings-modal-font-size-selection [form]="settingsForm" />
    <app-settings-contrast-mode-toggle [form]="settingsForm" />
  </div>
  <core-modal-footer slot="footer" (aborted)="modalRef.dismiss()" (submitted)="submit()" />
</core-modal-window>
